import esLocale from '@onesait/ods/lib/locale/lang/es'

export default {
  ...esLocale,
  'serverError': 'Ha ocurrido un error inesperado en el servidor. Inténtalo de nuevo.',
  'login': {
    'title': 'Iniciar sesión',
    'user': 'Nombre de usuario',
    'password': 'Contraseña',
    'submitButton': 'Enviar',
    'rules': {
      'user': 'Introduzca el usuario',
      'password': 'Introduzca la contaseña'
    },
    'logging': 'Iniciando sesión...',
    'loginErrorTitle': 'Error de validación.',
    'loginError': 'La combinación usuario/contraseña no es valida.',
    'forgotPassword': '¿Has olvidado tu contraseña?',
    'keepMeLogged': 'Mantener sesión iniciada',
    'login': 'Entrar',
    'footerLinks': ['faq', 'términos', 'condiciones']
  },
  'password': {
    'title': 'Restablecer contraseña',
    'message': 'Introduce una cuenta de correo electrónico vinculada al producto para continuar',
    'email': 'Correo electrónico',
    'submitButton': 'Enviar',
    'goBack': 'Volver',
    'error': 'Email no encontrado.',
    'sending': 'Enviando...',
    'rules': {
      'email': 'Email no encontrado'
    },
    'emailSubmitted': 'Hemos enviado un correo electrónico con instrucciones para poder restablecer su contraseña a:',
    'done': 'Finalizar',
    'emailError': 'No existe ninguna cuenta vinculada a este correo electrónico: '
  },
  'breadcrumb': {
    'dashboard': 'Dashboard',
    'dashboardPlatform': 'Dashboard plataforma',
    'predictiveModels': 'Modelos Predictivos',
    'createModel': 'Crear Modelo',
    'selectModel': 'Seleccionar Modelo',
    'parksAndGardens': 'Parques y Jardines',
    'mapCompare': 'Comparador',
    'environment': 'Medioambiente',
    'mobility': 'Movilidad',
    'autobuses': 'Autobuses',
    'bike': 'Bicicletas',
    'parking': 'Aparcamientos',
    'visualization': 'Visualizaciones',
    'cruises': 'Control de Flotas',
    'cruisesRealTime': 'Tiempo real',
    'cruisesHistoric': 'Histórico',
    'profile': 'Perfil',
    'crm': 'CRM Ciudadano',
    'rolesAdministration': 'Roles y Usuarios',
    'newRole': 'Nuevo rol',
    'newUser': 'Nuevo usuario',
    'editUser': 'Editar usuario',
    'newAdminMenu': 'Nuevo menu',
    'adminmenu': 'Administración del Menú',
    'editAdminMenu': 'Editar menú',
    'instalacionesdeportivas': 'Instalaciones Deportivas',
    'contaminaciónenelaire': 'Contaminación en el aire'
  },
  'notifications': {
    'popoverTitle': 'Notificaciones'
  },
  'months': {
    'January': 'Enero',
    'February': 'Febrero',
    'March': 'Marzo',
    'April': 'Abril',
    'May': 'Mayo',
    'June': 'Junio',
    'July': 'Julio',
    'August': 'Agosto',
    'September': 'Serptiembre',
    'October': 'Octubre',
    'November': 'Noviembre',
    'December': 'Diciembre'
  },
  'start': 'Inicio',
  'end': 'Fin',
  'all': 'todos',
  'nettle': 'Ortiga',
  'noise': 'Ruido',
  'noiseContaminationCoef': 'Contaminación de ruido COEF',
  'olive': 'Olivo',
  'grass': 'Gramínea',
  'chenopodiaceaeAmaranthaceae': 'Amarantacea',
  'daily': 'Hoy',
  'today': 'Hoy',
  'alerts': 'Alertas',
  'alert': 'Alerta',
  'Alert': 'Alerta',
  'campaigns': 'Campañas',
  'campaign': 'Campaña',
  'historic': 'Histórico',
  'social networks': 'Redes Sociales',
  'timeline': 'Timeline',
  'trends': 'Tendencias',
  'actives': 'Activas',
  'inactives': 'Inactivas',
  'level': 'Nivel',
  'environment-and-meteorology': 'Medioambiente y meteorología',
  'Environment and Metereology': 'Medioambiente y Meteorología',
  'Mobility and Transport': 'Movilidad y Transporte',
  'mobilityAndTransportation': 'Movilidad y Transporte',
  'environment': 'Medioambiente',
  'Environment': 'Medioambiente',
  'parksAndGardens': 'Parques y Jardines',
  'Meteorology': 'Metereología',
  'grain/m3': 'g/m³',
  'µg/m3': 'µg/m³',
  'g/m3': 'g/m³',
  'm3': 'm³',
  'high': 'Alto',
  'low': 'Bajo',
  'medium': 'Medio',
  'hour': 'Hora',
  'date': 'Fecha',
  'location': 'Localización',
  'responsable': 'Responsable',
  'viewerInMap': 'Visualizar en mapa',
  'period': 'Periodo',
  'wind': 'Velocidad de viento',
  'occupationRateSensorZones': 'Oc. Zonas de aparcamiento',
  'occupationRateParking': 'Oc. Parking públicos',
  'pressure': 'Presión',
  'temperature': 'Temperatura',
  'precipitation': 'Precipitación',
  'Sin variación': 'Without variation',
  'last 7 days': 'Últimos 7 Días',
  'Parks and Gardens': 'Parques y Jardines',
  'compare': 'comparar',
  'Predictive Models': 'Modelos Predictivos',
  'Create model': 'Creación de modelo',
  'Weather': 'Meteorología',
  'Wather': 'Meteorología',
  'AeroAllergen': 'Gramínia',
  'AirQuality': 'Calidad del aire',
  'noiseLevelKpi': 'Nivel de Ruido',
  'Ground': 'Información del suelo',
  'Counters': 'Contadores',
  'SolenoidValves': 'Electroválvulas',
  'Incidence': 'Incidencias',
  'incidence': 'Incidencias',
  'Irrigation': 'Consumo de agua',
  'CO2Absorption': 'Absorción de CO2',
  'humidity': 'Humedad',
  'startDate': 'Fecha inicio',
  'endDate': 'Fecha fin',
  'city': 'Ciudad',
  'View in map': 'Ver en mapa',
  'minimum': 'Mínimo',
  'maximum': 'Máximo',
  'Selected Element': 'Elemento Seleccionado',
  'chart': 'Gráfico',
  'All': 'Todos',
  'no data': 'Sin datos',
  'no data alerts today': 'No existen alertas para el día de hoy. Inténtelo de nuevo más tarde.',
  'no data alerts week': 'No existen alertas para los últimos 7 días. Inténtelo de nuevo más tarde.',
  'no data campaign active': 'No existen campañas activas. Inténtelo de nuevo más tarde.',
  'no data campaign inactive': 'No existen campañas inactivas. Inténtelo de nuevo más tarde.',
  'no data social timeline': 'No podemos cargar datos de Redes Sociales en este momento. Inténtelo de nuevo más tarde.',
  'no data social trends': 'No podemos cargar datos de "Tendencias" en este momento. Inténtelo de nuevo más tarde.',
  'no data kpi dashboard': 'No existen KPIs. Inténtelo de nuevo más tarde.',
  'no data kpi': 'No existen KPIs para el módulo seleccionado. Inténtelo de nuevo más tarde.',
  'no data kpi parkingPanel': 'Seleccione un panel para ampliar información',
  'no data kpi chart select': 'Seleccione un KPI para mostrar el gráfico.',
  'no data kpi chart': 'No existen KPIs para el módulo seleccionado. Inténtelo de nuevo más tarde.',
  'no data kpi chart suficient': 'No existen datos suficientes para formar la gráfica.',
  'no data kpi compare': 'No existen datos suficientes para poder comparar',
  'noVisualizationData': 'No hay visualizaciones para mostrar',
  'noResults': 'Sin resultados',
  'nivel': 'Nivel',
  'tipo': 'Tipo',
  'area': 'Área',
  'hora': 'Hora',
  'titulo': 'Título',
  'periodo': 'Período',
  'Throw': 'Lanzar',
  'days': 'días',
  'totalCO2Absorption': 'Absorción C02',
  'averageIncidentResolutionTime': 'Media tiempo resolución incidencias',
  'totalIncidences': 'Total incidencias',
  'units': '',
  'savingsWaterConsumption': 'Ahorro consumo agua',
  'waterConsumption': 'Consumo agua',
  'irrigationAverageTime': 'Tiempo Medio de Riego',
  'sprinklerDamaged': 'Aspersores dañados',
  'sprinklerTotal': 'Aspersores totales',
  'activationsIrrigationSystem': 'Activaciones de sistema de riego',
  'savingsAmountWaterConsumption': 'Ahorro coste consumo de agua',
  'amountWaterConsumption': 'Coste de consumo de agua',
  'fallenTreesOrBranches': 'Arboles o ramas caídas',
  'totalResolvedIncidences': 'Total Incidencias Resueltas',
  'alertsByPlague': 'Alertas por plaga',
  'co2AbsorptionByTreeSpecies': 'Absorción de CO2 por especies árboreas',
  'co2AbsorptionByBushesAndGardens': 'Absorción de CO2 por arbustos y jardines',
  'EligeCategoría': 'Elige Categoría',
  'Select': 'Seleccionar',
  'volverlistadoalertas': 'volver listado alertas',
  'volverlistadocampanias': 'volver listado campañas',
  'Informacióndeparques': 'Información de parques',
  'InfoParques': 'Información de parques',
  'infoParques': 'Información de parques',
  'Informacióndesuelo': 'Información del suelo',
  'AreadeInfluencia': 'Area de influencia',
  'Buscarenmapa': 'Buscar en mapa',
  'Visualization': 'Visualización',
  'load': 'cargar',
  'load visualizations': 'cargar visualizaciones',
  'cancel': 'cancelar',
  'update': 'actualizar',
  'occupationRate': '% ocupación',
  'availableSpot': 'plazas disponibles',
  'occupiedSpot': 'plazas ocupadas',
  'parkNoPayment': 'total de pagos',
  'park120min': 'aparcamientos inferiores a 120 min',
  'park60min': 'aparcamientos inferiores a 60 min',
  'park30min': 'aparcamientos inferiores a 30 min',
  'parkLimitExceded': 'estacionados que exceden el límite',
  'usesOfApp': 'usos de la aplicación',
  'fails': 'fallos del sistema',
  'pickaday': 'Selecciona día',
  'startdate': 'Fecha de inicio',
  'enddate': 'Fecha final ',
  'totalbikes': 'Bicicletas totales',
  'freeBikes': 'Bicicletas disponibles',
  'bike': 'Bicicletas',
  'bikes': 'Bicicletas ocupadas',
  'parking': 'Aparcamientos',
  'panelParking': 'Panel de aparcamientos',
  'parkingPanel': 'Panel de aparcamientos',
  'sensorZones': 'Zonas de sensores',
  'busStop': 'Paradas de autobús',
  'busLine': 'Líneas de autobús',
  'parkInformation': 'Información de parques',
  'users': 'Usuarios',
  'roundNoStop': 'Vueltas sin parada',
  'stops': 'Paradas',
  'usersByBusStop': 'Usuarios por parada',
  'timeBetweenBusStop': 'Tiempo entre paradas',
  'rounds': 'Vueltas',
  'paymentsByCard': 'Pagos en tarjeta',
  'totalUsers': 'Total de usuarios',
  'paymentsByCash': 'Pagos en efectivo',
  'timeByRound': 'Tiempo por vuelta',
  'paymentsByMobileEmv': 'Pagos en móvil',
  'usersByRound': 'Usuarios por vuelta',
  'busesUsed': 'Autobuses usados',
  'municipalServices': 'Servicios Municipales',
  'cruises': 'flotas',
  'Cruises': 'Flotas',
  'state': 'estado',
  'speed': 'velocidad',
  'description': 'descripción',
  'createDate': 'Fecha de creación',
  'createTime': 'Hora de creación',
  'cerrar': 'cerrar',
  'solicitudes': 'solicitudes',
  'liters': 'Litros',
  'kmrecorrido': 'Km recorridos',
  'kmahorrados': 'km ahorrados',
  'eficienciamediaconductores': 'Eficiencia media conductores',
  'kmemcimavelocidadpermitida': 'Km encima velocidad permitida',
  'fallosdevehiculo': 'Fallos de vehículo',
  'centralidadfuncional': 'Centralidad Funcional',
  'consumomedio': 'Consumo medio',
  'consumototal': 'Consumo total',
  'consumption': 'Consumo',
  'avgConsumption': 'Media de consumo',
  'citizens': 'Ciudadanos',
  'resolutionPeriod': 'Periodo de resolución',
  'slopesSolicitations': 'Solicitudes pendientes',
  'averagePerThousandPeople': 'Media / 1000 habitantes',
  'presenceSolicitations': 'Solicitudes (presencial)',
  'appSolicitations': 'Solicitudes (App)',
  'totalSolicitations': 'Solicitudes totales',
  'webSolicitations': 'Solicitudes (Web)',
  'resolvedSolicitations': 'Solicitudes resueltas',
  'availableProcedure': 'Procesos abiertos',
  'electronicsNotifications': 'Notificaciones electoronicas',
  'verageComplaintsConsultationsCitizen': 'verage Complaints Consultations Citizen',
  'percentageRegisteredCitizens': 'quejas / ciudadanos registrados',
  'registeredCitizens': 'ciudadanos registrados',
  'postMailNotifications': 'Notificaciones (correo postal)',
  'smsNotifications': 'Notificaciones (SMS)',
  'complaints': 'Quejas',
  'solicitations': 'Solicitudes',
  'consultations': 'Consultas',
  'damage': 'Averias',
  'suggestions': 'Sugerencias',
  'informationConsultations': 'Consultas',
  'predictive models': 'Modelos predictivos encontrados',
  'SELECT RESTRICTION LEVEL': 'SELECCIONA NIVEL DE RESTRICCIÓN',
  'save': 'Guardar',
  'export': 'Exportar',
  'calculate': 'Calcular',
  'Run the model to see its visualizations here': 'Ejecuta el modelo para ver aquí sus visualizaciones, KPIs, etc',
  'from': 'Desde',
  'Apply': 'Aplicar',
  'to': 'Hasta',
  'suddenBraking': 'Frenado repentino',
  'speeding': 'Exceso de velocidad',
  'sharpAccelerations': 'Aceleraciones bruscas',
  'Of the interval 1': 'Del intervalo 1',
  'with the interva 2': 'Con el intervalo 2',
  'Real Time': 'Tiempo Real',
  'Historic': 'Histórico',
  'Solicitations': 'Solicitudes',
  'Consultations': 'Consultas',
  'Complaints': 'Quejas',
  'Damage': 'Averias',
  'Nº Complaints': 'Nº de Quejas',
  'Transactions': 'Tramites',
  'Citizens': 'Ciudadanos',
  'Bus': 'Autobuses',
  'busRealTime': 'Autobuses',
  'fleetRealTime': 'Flotas',
  'Bike': 'Bicicletas',
  'Allergens': 'Alérgenos',
  'last day': 'Último día',
  'last seven days': 'Últimos 7 Días',
  'last thirty days': 'Últimos 30 Días',
  'last twelve months': 'Últimos 12 meses',
  'last five years': 'Últimos 5 años',
  'Spanish': 'Español',
  'English': 'Inglés',
  'Galician': 'Gallego',
  'Profile': 'Perfil',
  'LogOut': 'Cerrar Sesión',
  'withoutStage': 'Sin escenario',
  'LIMIT': 'LÍMITE',
  'ZONE': 'ZONA',
  'withoutRestrictions': 'SIN RESTRICCIONES',
  'ALLVEHICLES': 'TODOS LOS VEHÍCULOS',
  'Stage': 'Escenario',
  'paymentStatsCard': 'Tarjeta de estadísticas de pago',
  'usersUp': 'Usuario subidos',
  'paymentStatsMobileEMV': 'Estadísticas de pago móvil EMV',
  'paymentStatsCash': 'Estadísticas de pago Efectivo',
  'usersDown': 'Usuarios bajados',
  'predictiveModels': {
    'instalacionesdeportivas': 'Instalaciones Deportivas',
    'contaminaciónenelaire': 'Contaminación en el aire',
    'sportInstallationsDescription': 'Previsión de la evolución de la contaminación en el aire según niveles de restricción',
    'pollutionDescription': 'Previsión de la evolución de la contaminación en el aire según niveles de restricción',
    'levelsOf': 'Niveles de',
    'inAir': 'en el aire',
    'currentScene': 'Escenario actual',
    'infoScene': 'Escenario de información',
    'alarmScene': 'Escenario de alarma',
    'speedLimit': 'Límite de velocidad',
    'centerZone': 'Zona Centro',
    'allVehicles': 'Todos los vehículos',
    'notRestrictions': 'Sin Restricciones',
    'historical': 'Histórico',
    'prediction': 'Predicción',
    'alertLevel': ' Nivel de alerta',
    'month': 'MES',
    'currentMonthLabel': 'MES ACTUAL',
    'levelsCO2': 'Niveles de NO2 (µg/m3)',
    'type': 'TIPO',
    'ceroEmissions': 'CERO EMISIONES',
    'paddel': 'padel',
    'tennis': 'tenis',
    'soccer': 'futbol',
    'sportcenters': 'Centros deportivos',
    'search': 'Buscar',
    'center': 'Centro',
    'southzone': 'Zona Sur',
    'northzone': 'Zona Norte',
    'occupationinfacilitiesof': 'Ocupación en instalaciones de',
    'actualprice': 'Precio actual',
    'newprice': 'Nuevo precio',
    'occupationPercentage': 'Porcentaje de ocupación'
  },
  'parkings': {
    'streetAddress': 'Dirección',
    'totalSpotNumber': 'Plazas totales',
    'availableSpotNumber': 'Plazas disponibles',
    'occupiedSpot': 'Plazas ocupadas',
    'occupationRate': 'Tasa de ocupación'
  },
  'administration': {
    'roles': {
      'roles': 'Roles',
      'newRole': 'Nuevo rol',
      'editRole': 'Editar rol',
      'associateUsers': 'Asociar usuarios',
      'associatedUsers': 'Usuarios asociados',
      'availableUsers': 'Usuarios disponibles',
      'addMessage': 'Rol creado correctamente',
      'editSuccess': 'Rol editado correctamente',
      'editErrorMessage': 'Error al editar el rol',
      'createRoleError': 'El nombre del rol no puede existir',
      'createRoleErrorExist': 'Ya existe un rol con ese nombre',
      'assocPermissionsError': 'Error al asignar permisos',
      'deletePermissionsError': 'Error al eliminar permisos',
      'asoccUsersError': 'Error al asociar usuarios',
      'deleteRoleError': 'Error al eliminar el rol',
      'availablePermissions': 'Permisos disponibles',
      'associatedPermissions': 'Permisos asociados',
      'permissions': 'Permisos',
      'confirmMessage': 'Los usuarios que tengan asignado sólo este rol dejarán de poder acceder a la aplicación pero no se eliminarán del sistema',
      'confirmTitle': 'Confirmación de edición',
      'confirmDeleteTitle': 'Confirmación de eliminación',
      'warningTitle': 'Aviso',
      'deleteRoleAlertMessage': 'No se puede eliminar un rol que tenga usuarios asignados',
      'deleteRoleConfirmMessage': '¿Estas seguro de eliminar el rol ',
      'areYouSure': '¿está seguro?'
    },
    'users': {
      'users': 'Usuarios',
      'editUser': 'Editar usuario',
      'newUser': 'Nuevo usuario',
      'associatedRoles': 'Roles asociados',
      'availableRoles': 'Roles disponibles',
      'requiredPassword': 'Debe tener al entre 10 y 20 caracteres, al menos un dígito, al menos una minúscula, al menos una mayúscula y al menos un caracter no alfanumérico.',
      'differentPassword': 'La contraseñas no coinciden',
      'editMessage': 'El usuario "%{p1}" ha sido modificado con éxito',
      'editMessageError': 'Se ha producido un error al modificar al usuario "%{p1}"',
      'chagePassword': 'Cambiar contraseña',
      'chagePasswordInfo': 'La contraseña debe tener al entre 10 y 20 caracteres, al menos un dígito, al menos una minúscula, al menos una mayúscula y al menos un caracter no alfanumérico',
      'chagePasswordSuccess': 'Contraseña modificada correctamente',
      'chagePasswordError': 'Error al actualizar la contaseña'
    },
    'general': {
      'name': 'Nombre',
      'description': 'Descripción',
      'associatedUsers': 'Usuarios asociados',
      'email': 'Email',
      'generalData': 'Datos Generales',
      'cancel': 'Cancelar',
      'accept': 'Aceptar',
      'finish': 'Finalizar',
      'prevStep': 'Anterior',
      'nextStep': 'Siguiente',
      'confirm': 'Confirmar',
      'createSuccess': 'creado correctamente',
      'editSuccess': 'editao correctamente',
      'change': 'Cambiar'
    },
    'defaultForm': {
      'placeholder': 'Escriba aquí',
      'generalData': 'Datos Generales',
      'description': 'Descripción',
      'phone': 'Teléfono',
      'password': 'Contraseña',
      'repeatPassword': 'Repetir contraseña',
      'email': 'Email',
      'order': 'Orden',
      'url': 'Url'
    },
    'menus': {
      'menu': 'Menú',
      'availableSubmenu': 'Submenús dsiponibles',
      'associatedSubmenu': 'Submenús asociados',
      'addSubmenu': 'Añadir submenú',
      'addLanguage': 'Añadir idioma',
      'submenu': 'Submenú',
      'saveChanges': 'Guardar cambios',
      'deleteSubmenuConfirmMessage': '¿Estas seguro de eliminar el submenú ',
      'deleteMenuConfirmMessage': '¿Estas seguro de eliminar el menú ',
      'deleteSubmnenuConfirmTitle': 'Confirmar eliminar',
      'deleteMenuError': 'Error al eliminar el menú',
      'deleteMenusSuccess': 'Menú eliminado correctamente',
      'createMenuError': 'Error al crear el menú',
      'createMenuErrorExist': 'Ya existe un menú con ese nombre',
      'createMenuErrorOrder': 'Ya existe un menú con ese mismo orden y tipo',
      'newMenu': 'Menú creado correctamente',
      'editMenuSuCcessModal': 'Menú editado correctamente',
      'editMenuSuccess': 'Menú editado correctamente',
      'editMenuError': 'Error al editar el menú',
      'toRoles': 'Ir a roles',
      'toMenuList': 'Ir a menús',
      'editMenuTitle': 'Editar menú',
      'menuType': 'Tipo',
      'actions': 'Acciones'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/locale/es.js